export default "__VITE_ASSET__6WHt5L4W__"